var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorRobotFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219 204.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c3d8dd;}.cls-2{fill:#d5e8ef;}.cls-3{fill:#f2fafc;}.cls-4{fill:#353849;}.cls-5{fill:#51f2e2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.29,
    y: 19.7,
    width: 8.41,
    height: 32.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.42,99.17H219a0,0,0,0,1,0,0V159a0,0,0,0,1,0,0H203.42a26.4,26.4,0,0,1-26.4-26.4v-7A26.4,26.4,0,0,1,203.42,99.17Z",
    transform: "translate(396.02 258.14) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.4,99.17H42a0,0,0,0,1,0,0V159a0,0,0,0,1,0,0H26.4A26.4,26.4,0,0,1,0,132.57v-7A26.4,26.4,0,0,1,26.4,99.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.75,
    y: 55.1,
    width: 173.5,
    height: 149.62,
    rx: 61.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.75,
    y: 45.63,
    width: 173.5,
    height: 149.62,
    rx: 61.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.13,
    y: 55.98,
    width: 100.74,
    height: 136,
    rx: 40.89,
    transform: "translate(233.48 14.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 61.4,
    y: 61.99,
    width: 96.2,
    height: 132.49,
    rx: 39.83,
    transform: "translate(237.74 18.74) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 109.5,
    cy: 14,
    r: 14,
    transform: "translate(2.88 42.6) rotate(-22.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.5,139.73c7.74,0,14.73,4.11,17.8,10.49a3.31,3.31,0,1,1-6,2.87c-2-4.1-6.62-6.74-11.84-6.74s-9.86,2.64-11.83,6.74a3.31,3.31,0,0,1-6-2.87C94.77,143.84,101.76,139.73,109.5,139.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.25,131.93a4,4,0,0,1-2.83-1.17l-13-13a4,4,0,0,1,5.66-5.66l13,13a4,4,0,0,1-2.83,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.25,131.93a4,4,0,0,1-2.83-6.83l13-13a4,4,0,0,1,5.66,5.66l-13,13A4,4,0,0,1,71.25,131.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.75,131.93a4,4,0,0,1-2.83-1.17l-13-13a4,4,0,0,1,5.66-5.66l13,13a4,4,0,0,1-2.83,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M134.75,131.93a4,4,0,0,1-2.83-6.83l13-13a4,4,0,0,1,5.66,5.66l-13,13A4,4,0,0,1,134.75,131.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRobotFace);
export default __webpack_public_path__ + "static/media/ErrorRobotFace.62b5fca0fdd344e54aa21accf40de210.svg";
export { ForwardRef as ReactComponent };